import React from "react";
import { Box, Text } from "@origin-digital/ods-core";
import { getNameAbbreviation } from "../helpers";
import { SvgIcon } from "@mui/material";

export const OriginUserAvatar = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    backgroundColor="primaryB"
    borderRadius="large"
    marginRight="xsmall"
    style={{
      height: "24px",
      width: "24px",
    }}
  >
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.347586 4.95614C1.28915 1.99737 3.97375 -0.00268613 7 2.70779e-06C10.0262 -0.00268613 12.7108 1.99737 13.6524 4.95614C14.594 7.91491 13.5789 11.161 11.137 13C8.67481 11.1416 5.32519 11.1416 2.86301 13C0.42112 11.161 -0.593983 7.91491 0.347586 4.95614ZM3.43234 7.19667C3.43179 9.22459 5.02877 10.8693 7 10.871C7.94801 10.8718 8.85742 10.4847 9.52776 9.79511C10.1981 9.10548 10.5744 8.16992 10.5736 7.19464C10.5719 5.16671 8.9732 3.5238 7.00197 3.52436C5.03074 3.52492 3.43288 5.16874 3.43234 7.19667Z"
        fill="white"
      />
    </svg>
  </Box>
);

export const getCustomerAvatar = (authorName: string) => (
  <Box backgroundColor="info" borderRadius="large" marginRight="xsmall">
    <Text
      weight="medium"
      align="center"
      tone="white"
      // @ts-expect-error: we need customise style
      style={{
        fontSize: "10px",
        height: "24px",
        width: "24px",
      }}
    >
      {getNameAbbreviation(authorName)}
    </Text>
  </Box>
);

export const FileUploadButtonIcon = () => (
  <SvgIcon color="inherit">
    <path d="M16.5 6.75v10.58c0 2.09-1.53 3.95-3.61 4.15A3.993 3.993 0 0 1 8.5 17.5V5.14c0-1.31.94-2.5 2.24-2.63A2.5 2.5 0 0 1 13.5 5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v8.61c0 1.31.94 2.5 2.24 2.63A2.5 2.5 0 0 0 15 15.5V5.17c0-2.09-1.53-3.95-3.61-4.15A3.998 3.998 0 0 0 7 5v12.27c0 2.87 2.1 5.44 4.96 5.71 3.29.3 6.04-2.26 6.04-5.48V6.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75Z" />
  </SvgIcon>
);

export const MarkAsReadButtonIcon = () => (
  <SvgIcon color="inherit">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm-.4 4.25-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25a.85.85 0 1 1 .9-1.44L12 11l6.7-4.19a.85.85 0 1 1 .9 1.44Z" />
  </SvgIcon>
);

export const SelectedFileIcon = () => (
  <Box marginRight="small">
    {/*@ts-expect-error: it works but throws error in ts*/}
    <SvgIcon color="neutral">
      <path d="M8 16h8v2H8v-2Zm0-4h8v2H8v-2Zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6Zm4 18H6V4h7v5h5v11Z" />
    </SvgIcon>
  </Box>
);

export const DropFileIcon = () => (
  /*@ts-expect-error: it works but throws error in ts*/
  <SvgIcon color="info" size="smallmedium">
    <path d="M11 16V7.85L8.4 10.45L7 9L12 4L17 9L15.6 10.45L13 7.85V16H11ZM6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6Z" />
  </SvgIcon>
);
